module.exports = __webpack_public_path__ + "img/productos.8e3918c7.jpeg";